<template>
  <tr
    class="cat-revise-item reviseItemRow"
    :role="roleListItem ? 'listitem' : null"
  >
    <td
      :role="roleListItem ? 'group' : null"
      :aria-label="roleListItem ? groupDetailsLabel : null"
    >
      <div class="item-row">
        <cat-icon
          v-if="icon"
          class="item-icon"
          :icon="icon"
          :iconLabel="iconLabel ? iconLabel : icon"
        ></cat-icon>
        <div>
          <span v-if="itemName" class="item-name">{{ itemName }}&nbsp;</span>
          <small v-if="itemNumber" class="item-number"
            >({{ itemNumber }})</small
          >
          <div v-if="service || createdDate">
            <small v-if="service" class="item-service">{{
              service + " "
            }}</small>
            <small v-if="createdDate" class="item-created">{{
              createdDate
            }}</small>
          </div>
          <div v-if="status != '' || expireDate">
            <cat-pill class="item-status" :value="status" :level="statusCode" />
            <small v-if="status === 'Expired'" class="item-expires">{{
              expireDate
            }}</small>
          </div>

          <cat-errors
            v-if="reasons && (reasons.reasons || reasons.comments)"
            class="mts"
            :errors="getErrors(reasons)"
          ></cat-errors>

          <div v-if="referenceNumber && referenceNumber !== 'Reference No:'">
            <small class="myItemReference">{{ referenceNumber }}</small>
          </div>

          <cat-errors
            v-if="notification && notification.displayInline == true"
            :errors="[
              {
                messages: [{ msg: notification.message }],
                level: notification.level,
                msg: notification.message
              }
            ]"
          />
          <cat-error
            v-else-if="notification"
            :level="parseInt(notification.level)"
            :center="false"
            class="small"
          >
            <ul class="alert-items">
              <li class="alert-item">{{ notification.message }}</li>
            </ul>
          </cat-error>
          <cat-pill v-if="pill" :value="pillValue" level="warn" />
        </div>
      </div>
    </td>
    <td
      :role="roleListItem ? 'group' : null"
      :aria-label="roleListItem ? groupActionsLabel : null"
    >
      <slot></slot>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CatPill from "../catPill/cat-pill";
import CatError from "../catError/catError";
import CatIcon from "../utilities/catIcon";
import DashboardItemsMixin from "./dashboard-items-mixin";

export default defineComponent({
  name: "CatReviseItem",
  mixins: [DashboardItemsMixin],
  components: { CatError, CatPill, CatIcon }
});
</script>
